/*
 * @Author: cc
 * @Date: 2021-07-20 17:53:07
 * @LastEditTime: 2021-10-12 11:37:59
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\manageConfigRouter.js
 * @Description: 
 */
/*
    Create By Baizhiming 2015-10-14
*/
'use strict';
angular.module('manageCfg', [
    'manageCfg.roleManageMent',
    'groupUserManageMentRouterModule',
    'roleManageModule',
    'sysmanageModule',
    'productManageMentModule',
    'initManageConDropDownModule',
    'tenantManageMentModule',
    'departmentManuIframeModule'
]).config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('manageconfig', {
            url: '/manageconfig',
            views: {
                '': {
                    templateUrl: './manageConfig/main_tpl.html',
                    controller: 'manageConfigCtrl'
                },
                'header@manageconfig': {
                    templateUrl: './manageConfig/header_tpl.html',
                    controller: 'manageConfigHeaderCtrl'
                }
            }
        })
        .state('manageconfig.newrolemanage', {
            url: '/newrolemanage',
            views: {
                'main@manageconfig': {
                    templateUrl: './manageConfig/roleManageMent/iframe_tpl.html',
                    controller: 'roleManageMentIframeCtrl'
                }
            }
        }).state('manageconfig.departmentmanu', {
            url: '/departmentmanu',
            views: {
                'main@manageconfig': {
                    templateUrl: './manageConfig/departmenManusManageMent/iframe_tpl.html',
                    controller: 'departmentManuIframeCtrl'
                }
            }
        })
        .state('manageconfig.rolemanage', {
            url: '/rolemanage?groupid&roleid',
            views: {
                'main@manageconfig': {
                    templateUrl: './manageConfig/roleManageMent/roleManageMent_tpl.html',
                    controller: 'roleManageMentCtrl'
                }
            }
        })
        .state('manageconfig.productmanage', {
            url: '/productmanage',
            views: {
                'main@manageconfig': {
                    templateUrl: './manageConfig/productManageMent/main_tpl.html',
                    controller: 'productManageMentController'
                },
                'left@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/left_tpl.html',
                    controller: 'productManageMentLeftController'
                }
            }
        })
        .state('manageconfig.sysmanage', {
            url: '/sysmanage',
            views: {
                'main@manageconfig': {
                    templateUrl: './manageConfig/sysManageMent/main_tpl.html',
                    controller: 'SysmanageController'
                }
            }
        })
        .state('manageconfig.tenantmanagement', {
            url: '/tenantmanagement',
            views: {
                'main@manageconfig': {
                    templateUrl: './manageConfig/tenantManageMent/main_tpl.html',
                    controller: 'tenantManageMentCtrl'
                }
            }
        });
}]);
